// Paramètres du camion Pizz'n Co pour le calcul de l'heure proposée (§4).
// Valeurs À CALIBRER en session Coralie (cadence/marge/inclusion en_finalisation).
import type { HeureProposeeConfig } from '../lib/heure-proposee';
import type { HeureCapaciteConfig } from '../lib/heure-capacite';

export const CAMION_HEURE_CONFIG: HeureProposeeConfig = {
  fourCapacite: 4,
  cadenceFourMin: 8,
  margeMin: 5,
  arrondiMin: 5,
};

// Pas d'ajustement manuel de l'heure (±), en minutes (steppers T1).
export const AJUSTEMENT_PAS_MIN = 5;

// Moteur créneaux/capacité (LOT 7 §3) — HYPOTHÈSE DE DÉMARRAGE, configurable
// (à calibrer avec Coralie). Remplace l'usage UI de CAMION_HEURE_CONFIG
// (conservée ci-dessus, plus référencée par l'UI).
export const CAMION_CAPACITE_CONFIG: HeureCapaciteConfig = {
  capaciteParCreneau: 2,
  dureeCreneauMin: 5,
};
